import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CloseIcon from '@material-ui/icons/Close';
import { CONTINUE_WATCHING, slideBy } from '../../url.js'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import axios from 'axios';
import $ from 'jquery'
import FadeIn from "react-lazyload-fadein";

import placeholder from '../../assests/images/horPlaceholder.jpg';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ZoomThumbnail from './zoomThumbnail.js';
import parse from 'html-react-parser';

class ContinueWatchingThumbnail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 900,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 2500,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll:6,
                        },
                    },
                    {
                        breakpoint: 2000,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll:5,
                        },
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll:5,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow:3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },

                ],
            },
            Muted: false,
            isVideoThumbonHover: false,
            thumbnailIndex: 0
        }

    }
    continuewacthdelete = async (item) => {
        const token = localStorage.getItem('token')
        let entryid = item.entryid
        let formData = new FormData();
        formData.append("tag", "delete");
        formData.append("entryid", entryid);
        await axios.post(CONTINUE_WATCHING, formData, {
            headers: {
                'token': token
            }
        })
            .then(response => {
                if (response.status === 200) {
                    let msg = response.data.Message
                    $("#snackbar .msg").html(msg);
                    $("#snackbar")
                        .addClass("show")
                        .addClass("bg-success")
                        .removeClass("bg-danger");
                    setTimeout(function () {
                        $("#snackbar").removeClass("show").removeClass("bg-danger");
                    }, 3000);
                    window.location.reload()
                }
            }).catch((error) => {
                let msg = error.data.Message
                $("#snackbar .msg").html(msg);
                $("#snackbar")
                    .addClass("show")
                    .addClass("bg-danger")
                    .removeClass("bg-success");
                setTimeout(function () {
                    $("#snackbar").removeClass("show").removeClass("bg-danger");
                }, 3000);
            })
    }

    hoverThumbnail = (key) => {
        this.setState({ isVideoThumbonHover: true, thumbnailIndex: key })
    }

    hoverOutThumbnail = () => {
        this.setState({ isVideoThumbonHover: false })
    }

    render() {
        const { sliderItem } = this.state;
        return (
            <div className="pt-3 sliderWrapperRef">
                <div className="row thm_slr_bx">
                    <div className="thm_hdng_wppr d-flex align-item-center justify-content-between">
                        <h3>
                            CONTINUE WATCHING
                        </h3>
                    </div>

                    <Slider {...this.state.settings} className='thumb_slider position-relative continueWatching'>
                        {
                            this.props.data !== undefined && this.props.data !== null && this.props.data !== '' && this.props.data.map((item, key) => {
                                let totalDuration = item.total_duration / 1000;
                                return (
                                    <div className="thm_sldr_itm" onMouseOver={(e) => this.hoverThumbnail(key)} onMouseLeave={(e) => this.hoverOutThumbnail(key)} key={key} >
                                        <button type="button" className='dlt-btn' onClick={() => { this.continuewacthdelete(item) }}> </button>
                                        <div className={`wtch-lst`}>
                                            <Link to={`/video/cat/${(item.name.replace(/\s/g, '')).toLowerCase()}/${item.entryid !== null && item.entryid !== undefined ? item.entryid : window.btoa(this.props.Itmdata.categoryid)}`} className={`box`}>
                                                <div className='placeholder hor'>
                                                    <img alt="placeholder" src={placeholder} className="w-100 placeholderImg" />
                                                    <div className="thumbImg">
                                                        <FadeIn height={180}>
                                                            {onload => (
                                                                <img
                                                                    src={item.thumburl.size_1080_1920 ? item.thumburl.size_1080_1920 + "/width=320/height=180/quality=100" : item.thumburl.h_thumburl ? item.thumburl.h_thumburl + "/width=320/height=180/quality=100" : item.thumburl.v_thumburl ? item.thumburl.v_thumburl + "/width=320/height=180/quality=100" : item.thumburl.size_default + "/width=320/height=180/quality=100"}
                                                                    alt="" key={'carousel_continueWacthing_' + key}
                                                                    onLoad={onload}
                                                                    className="thumbPlaceholder"
                                                                />
                                                            )}
                                                        </FadeIn>
                                                    </div>
                                                </div>
                                                <div className="rng-sldr">
                                                {/* <ProgressBar now={Math.floor((item.played_duration*100) / totalDuration)} /> */}
                                                <div className="video_played"><span style={{ width: `${Math.floor(((item.played_duration/1000) * 100) / totalDuration)}%` }}></span></div>
                                                {/* <ProgressBar now={'50'} /> */}
                                            </div>
                                            
                                            </Link>
                                        </div>

                                        {
                                            this.state.isVideoThumbonHover === true && this.state.thumbnailIndex===key &&
                                        <ZoomThumbnail title={item.name} description={parse(item.description.substr(0,170)+'...')} pageLink={`/video/cat/${(item.name.replace(/\s/g, '')).toLowerCase()}/${item.entryid !== null && item.entryid !== undefined ? item.entryid : window.btoa(this.props.Itmdata.categoryid)}`} videoUrl="https://www.w3schools.com/html/mov_bbb.mp4" playing={this.state.isVideoThumbonHover} isAddedinWishList={false}/> 
                                        }
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        );
    }
}

export default ContinueWatchingThumbnail;
